import React, { useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import NumberFormat from 'react-number-format'
import { VIEW_DETAILS_COMMON_KEYS, VIEW_FT_DETAILS_KEYS } from '../../utils/translation-constants'
import { useTranslation } from 'react-i18next'

export default function FundTransferDetails({ option = {} }) {
  const [srcRequest, setSrcRequest] = useState(JSON.parse(option.srcRequest) || {})
  const { t } = useTranslation()
  const srcDetails = JSON.parse(option?.srcRequest)
  return (
    <Row xs={12}>
      <Col classname='col' xs={'6'} sm={'6'} md={'6'}>
        <label>{t(VIEW_FT_DETAILS_KEYS.SENDER_ACCOUNT_NO)}</label>
        <span>{option?.srcAcc || '-'}</span>
        <label>{t(VIEW_FT_DETAILS_KEYS.SENDER_BARNCH)}</label>
        <span>{srcRequest?.fin?.srcAccBranch || '-'}</span>
        <label>{t(VIEW_FT_DETAILS_KEYS.SENDER_CURRENCY)}</label>
        <span>{srcRequest?.fin?.srcAccCcy || '-'}</span>
        <label>{t(VIEW_FT_DETAILS_KEYS.AMOUNT)}</label>
        <span>
          <NumberFormat
            value={option?.amount}
            displayType={'text'}
            thousandSeparator={true}
            prefix={''}
            fixedDecimalScale={true}
            decimalScale={2}
            allowEmptyFormatting
          />
        </span>
        <label>{t(VIEW_FT_DETAILS_KEYS.EMAIL_ID)}</label>
        <span>{srcRequest?.nfin?.beneficiaryMail || '-'}</span>
        <label>{t(VIEW_FT_DETAILS_KEYS.MOBILE_NO)}</label>
        <span>{srcRequest?.nfin?.beneficiaryMobile || '-'}</span>
        <label>{t(VIEW_FT_DETAILS_KEYS.CURRENT_LEVEL)}</label>
        <span>{option?.currentLevel || '-'}</span>
        <label>{t(VIEW_FT_DETAILS_KEYS.RECEIVER_ACCOUNT_NO)}</label>
        <span>{option?.destAcc || '-'}</span>
        <label>{t(VIEW_FT_DETAILS_KEYS.RECEIVER_BARNCH)}</label>
        <span>{srcRequest?.fin?.destAccBranch || '-'}</span>
        <label>{t(VIEW_FT_DETAILS_KEYS.RECEIVER_CURRENCY)}</label>
        <span>{srcRequest?.fin?.destAccCcy || '-'}</span>
      </Col>
      <Col classname='col' xs={'6'} sm={'6'} md={'6'}>
        <label>{t(VIEW_FT_DETAILS_KEYS.BENEFICIARY_NAME)}</label>
        <span>{option?.beneName || '-'}</span>
        <label>{t(VIEW_FT_DETAILS_KEYS.TRANSFER_MODE)}</label>
        <span>
          {option?.transferType === 'DDACC' && t(VIEW_FT_DETAILS_KEYS.DDACC)}
          {option?.transferType === 'RTGS' && t(VIEW_FT_DETAILS_KEYS.RTGS)}
          {option?.transferType === 'THIRD_PARTY' && t(VIEW_FT_DETAILS_KEYS.OTHER)}
          {option?.transferType === 'SWIFT' && t(VIEW_FT_DETAILS_KEYS.SWIFT)}
          {option?.transferType === 'INTERNATIONAL' && t(VIEW_FT_DETAILS_KEYS.SWIFT)}
          {option?.transferType === 'OAT' && t(VIEW_FT_DETAILS_KEYS.OAT)}
          {option?.transferType === 'IAT' && t(VIEW_FT_DETAILS_KEYS.IAT)}
          {option?.transferType === null && ''}
          {option?.transferType === undefined && ''}

          {/* {option?.transferType === 'DDACC' && 'Third Party Transfer'}
          {option?.transferType === 'DDACC' ||
          option?.transferType === 'RTGS' ||
          option?.transferType === 'THIRD_PARTY'
            ? 'Third Party Transfer'
            : option?.transferType === 'OAT'
            ? 'Own Account Transfer '
            : option?.transferType === 'INTERNATIONAL'
            ? 'International Transfer'
            : 'Internal Account Transfer'} */}
        </span>

        {(option?.transferType === 'DDACC' ||
          option?.transferType === 'RTGS' ||
          option?.transferType === 'THIRD_PARTY') && (
          <>
            <div className='d-flex'>
              <div>
                <label>{t(VIEW_FT_DETAILS_KEYS.BIC_CODE)}</label>
                <span>{srcRequest?.fin?.bicCode || '-'}</span>
              </div>

              <div style={{ marginLeft: 20 }}>
                <label>{t(VIEW_FT_DETAILS_KEYS.SORT_CODE)}</label>
                <span>{srcRequest?.fin?.sortCode || '-'}</span>
              </div>
            </div>

            <label>{t(VIEW_FT_DETAILS_KEYS.BANK_NAME)}</label>
            <span>{option?.bankName || '-'}</span>
          </>
        )}

        {option?.transferType === 'INTERNATIONAL' && (
          <>
            <label>{t(VIEW_FT_DETAILS_KEYS.SWIFT_CODE)}</label>
            <span>{option?.swiftCode || '-'}</span>
            <label>{t(VIEW_FT_DETAILS_KEYS.BANK_NAME)}</label>
            <span>{option?.bankName || '-'}</span>
          </>
        )}

        <label>{t(VIEW_FT_DETAILS_KEYS.TRANSACTION_REF_NO)}</label>
        <span>{option?.trnRefNo || '-'}</span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.INITIATED_BY)}</label>
        <span>{option?.initBy || '-'}</span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.INITIATED_DATE)}</label>
        <span>{option?.initDate !== null ? option?.initDate : '-'}</span>
        <label>{t(VIEW_FT_DETAILS_KEYS.REMARKS)}</label>
        <span>{srcDetails?.fin?.remarks || '-'}</span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.AUTHORIZED_DATE)}</label>
        <span>{option?.authDate !== null ? option?.authDate : '-'}</span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.AUTHORIZED_STATUS)}</label>
        <span>
          {option?.authStatus === 'P'
            ? 'Pending'
            : option?.authStatus === 'A'
            ? 'Approved'
            : 'Rejected'}
        </span>
        <label>{t(VIEW_DETAILS_COMMON_KEYS.COMMENTS)}</label>
        <span>{option?.authorizerComments || '-'}</span>
      </Col>
    </Row>
  )
}
